export const MEDIDAS_PREVENTIVAS = {
  INVESTIGACAO_INTERNA: "Investigação Interna",
  AFASTAMENTO_TEMPORARIO: "Afastamento Temporário do Agressor",
  ACOMPANHAMENTO_PSICOLOGICO: "Acompanhamento Psicológico",
} as const;
